export default "__VITE_ASSET__CqWvxLiR__"